// Methods not using "this" are implementing the interface and cannot be static
/* eslint-disable class-methods-use-this */

import { AxiosResponse } from 'axios';
import { OpenedAccountSettings } from './OpenedAccountSettings';
import VersionedResource from '../VersionedResource';
import { StatusSettingsResource } from './StatusSettingsResource';
import { StatusSettings } from './StatusSettings';

export class OpenedAccountSettingsResource extends VersionedResource implements StatusSettingsResource {
  public async getOne(fiId: string): Promise<OpenedAccountSettings> {
    const response: AxiosResponse = await this.apiClient.get(`/api/rcx/config/${fiId}/opened-account-settings`);
    const settings: OpenedAccountSettings = response.data.data;
    return settings;
  }

  public async save(fiId: string, settings: OpenedAccountSettings): Promise<OpenedAccountSettings> {
    const url = `/api/rcx/config/${fiId}/opened-account-settings/`;

    const response: AxiosResponse = await this.apiClient.put(url, settings);

    const savedSetting: OpenedAccountSettings = response.data.data;
    return savedSetting;
  }

  createEmptySettings(): OpenedAccountSettings {
    return {
      statusCodes: [],
      active: true,
    };
  }

  setIndicatorsOnSettings(settings: StatusSettings, values: string[], conditionalOr: boolean | null) {
    // Opened has no indicator option, so nothing to do here.
  }

  getIndicatorsFromSettings(settings: StatusSettings): string[] | null {
    // Opened has no indicator option, so nothing to do here.
    return null;
  }

  getConditionalFromSettings(settings: StatusSettings): string | null {
    // Opened has no indicator option, so nothing to do here.
    return null;
  }
}

export default OpenedAccountSettingsResource;
